import { setCookie, getCookie } from '../functions.js';

const ALLCOOKIESVALUE = 'allcookies';
const NOCOOKIESVALUE = 'nocookies';

document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.dataLayer === 'undefined') window.dataLayer = [];

    let cookieConsentEl = document.getElementById('cookie-consent');
    let cookieToggleEl = document.getElementById('cookie-toggle');

    let cookieAcceptButton = document.getElementById('cookie-accept');
    let cookieAcceptAllButton = document.getElementById('cookie-accept-all');
    let deleteButton = cookieConsentEl.querySelector('.delete');

    let cookieCheckboxes = document.querySelectorAll('.cookie-group input[type="checkbox"]');

    if (!cookieConsentEl || cookieCheckboxes.length === 0) {
        if (cookieToggleEl) {
            cookieToggleEl.classList.toggle('is-hidden');
        }
        return;
    }

    let cookieConsent = getCookie('occ');

    if (cookieConsent) {
        if (cookieConsent === ALLCOOKIESVALUE) {
            for (let i = 0; i < cookieCheckboxes.length; i++) {
                cookieCheckboxes[i].checked = true;
            }
        }
        if (cookieConsent !== (ALLCOOKIESVALUE || NOCOOKIESVALUE)) {
            for (let i = 0; i < cookieCheckboxes.length; i++) {
                if (cookieConsent.indexOf(cookieCheckboxes[i].value) !== -1) {
                    cookieCheckboxes[i].checked = true;
                }
            }
        }
    } else {
        toggleCookieConsentEl();
    }

    if (cookieAcceptButton) {
        cookieAcceptButton.addEventListener('click', () => {
            setCookieConsent();
        });
    }

    if (deleteButton) {
        deleteButton.addEventListener('click', () => {
            setCookieConsent();
        });
    }

    if (cookieAcceptAllButton) {
        cookieAcceptAllButton.addEventListener('click', () => {
            for (let i = 0; i < cookieCheckboxes.length; i++) {
                cookieCheckboxes[i].checked = true;
            }
            setCookie('occ', ALLCOOKIESVALUE, 365);
            toggleCookieConsentEl();
        });
    }

    if (cookieToggleEl) {
        cookieToggleEl.addEventListener('click', () => {
            toggleCookieConsentEl();
        });
    }

    function toggleCookieConsentEl() {
        cookieConsentEl.classList.toggle('is-hidden');

        if (toggleCookieConsentEl) {
            cookieToggleEl.classList.toggle('is-hidden');
        }
    }

    function setCookieConsent() {
        let cookieValueString = '';
        let cookievalueArray = [];

        for (let i = 0; i < cookieCheckboxes.length; i++) {
            if (cookieCheckboxes[i].checked) {
                cookievalueArray.push(cookieCheckboxes[i].value);
            }
        }

        if (cookievalueArray.length === cookieCheckboxes.length) cookieValueString = ALLCOOKIESVALUE
        if (cookievalueArray.length === 0) cookieValueString = NOCOOKIESVALUE

        let cookieValue = cookieValueString ? cookieValueString : cookievalueArray

        setCookie('occ', cookieValue, 365);
        toggleCookieConsentEl();
    }
});
